<template>
  <a-button v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-button>
</template>

<script setup lang="ts">
defineOptions({
  name: 'AntButton',
  inheritAttrs: false
})
</script>
<style lang="less">
.normal {
  border: 1px solid #0C418F;
  color: #0C418F;
  border-radius: 4px;
}

.search {
  background: #0B0B0B;
  border-color: #0B0B0B;
  color: #fff;
  border-radius: 2px;
}

.resetFun {
  background: #685241;
  border-color: #685241;
  color: #fff;
  border-radius: 2px;
}

.add {
  background: #39ceb0;
}
</style>
